import { useContext } from 'react';
import { createStyles } from '@mantine/core';

import { Avatar } from '~/domains/design-system/Avatar';
import { RootModalsContext } from '~/domains/common/context/RootModalsContext/RootModalsContext';
import type { UserEntrant } from '~/domains/contest/domains/services/interfaces/entrant.interface';

const useStyles = createStyles(() => ({
  container: {
    position: 'relative',
    display: 'inline-block',
  },
}));

function GamecenterStandingsAvatar({
  contestId,
  entrant,
  size,
}: {
  contestId: string;
  entrant: Partial<UserEntrant>;
  size?: number;
}) {
  const { openModal } = useContext(RootModalsContext);
  const { classes } = useStyles();

  const handleEntrantClick = (userEntrant: Partial<UserEntrant>) => {
    openModal({
      type: 'EntrantDetailModal',
      entrant: userEntrant,
      contestId,
      source: 'gamecenter_standings_slates',
    });
  };

  return (
    <div className={classes.container}>
      <div
        role="button"
        tabIndex={0}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleEntrantClick(entrant);
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.stopPropagation();
            handleEntrantClick(entrant);
          }
        }}
      >
        <Avatar src={entrant?.avatarUrl} handle={entrant?.handle} size={size} />
      </div>
    </div>
  );
}

export default GamecenterStandingsAvatar;
